<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form class="box" label-width="70px">
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.name')">{{
                  factory.name
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('factory.xcxViewImages')">{{
                  $t("boolean." + factory.xcxViewImages)
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="90px"
                  :label="$t('factory.xcxViewPhasePrice')"
                  >{{
                    $t("boolean." + factory.xcxViewPhasePrice)
                  }}</el-form-item
                >
              </el-col>
            </el-row>
          </fieldset>
          <el-row :gutter="10">
            <el-col :span="12">
              <fieldset class="mgb15">
                <legend>
                  {{ $t("factory.user") }}&nbsp;&nbsp;
                  <i
                    class="el-icon-circle-plus green"
                    @click="addUserFactory"
                  />
                </legend>
                <template v-if="factoryUsers.length != 0">
                  <el-tag
                    v-for="factoryUser in factoryUsers"
                    :key="factoryUser.userId"
                    closable
                    type="info"
                    @close="deleteUserFactory(factoryUser)"
                    >{{ factoryUser.user && factoryUser.user.name }}</el-tag
                  >
                </template>
              </fieldset>
            </el-col>
            <el-col :span="12">
              <fieldset class="mgb15">
                <legend>
                  {{ $t("factory.phaseAndPrice") }}&nbsp;&nbsp;
                  <i class="el-icon-circle-plus green" @click="addPhasePrice" />
                </legend>

                <vxe-table
                  :data="phasePrices"
                  row-id="id"
                  ref="recordsTable"
                  class="recordsTable"
                  size="mini"
                  resizable
                  round
                  border
                  highlight-hover-row
                  auto-resize
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column
                    field="phaseName"
                    :title="$t('menu.phases')"
                  />
                  <vxe-table-column
                    field="naphasePriceme"
                    :title="$t('factory.phasePrice')"
                  >
                    <template v-slot="{ row }">{{
                      row.phasePrice | currency
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="action"
                    :title="$t('text.action')"
                    width="100"
                  >
                    <template v-slot="{ row }">
                      <el-button
                        type="text"
                        size="mini"
                        @click="editPhasePrice(row)"
                        >{{ $t("text.edit") }}</el-button
                      >
                      <el-button
                        type="text"
                        size="mini"
                        @click="deletePhasePrice(row)"
                        >{{ $t("text.delete") }}</el-button
                      >
                    </template>
                  </vxe-table-column>
                </vxe-table>
              </fieldset>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 用户 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addUserFactoryDF"
      width="30%"
    >
      <el-form ref="addObjForm" label-width="80px">
        <el-checkbox-group v-model="checkedUserIds">
          <el-checkbox
            size="small"
            v-for="user of usersFilter"
            :key="user.id"
            :label="user.id"
            >{{ user.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addUserFactoryDoing"
          size="small"
          @click="addUserFactorySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addUserFactoryDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 工序 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addPhasePriceDF"
      width="30%"
    >
      <el-form
        ref="addPhasePriceObjForm"
        :model="addPhasePriceObj"
        label-width="70px"
      >
        <el-form-item
          :label="$t('menu.phases')"
          :prop="'phaseId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.phases')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="addPhasePriceObj.phaseId"
            filterable
            clearable
          >
            <el-option
              v-for="phase in phasesFilter"
              :key="phase.id"
              :label="phase.name"
              :value="phase.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('factory.phasePrice')"
          :prop="'phasePrice'"
          :rules="[
            { required: true, validator: validatePhasePrice, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addPhasePriceObj.phasePrice"
            :placeholder="$t('factory.phasePrice')"
          />
        </el-form-item>
        <el-form-item :prop="'asyncPhasePlan'">
          <el-checkbox size="small" v-model="addPhasePriceObj.asyncPhasePlan">{{
            $t("prompt.asyncPhasePlan")
          }}</el-checkbox>
        </el-form-item>
        <el-form-item :prop="'asyncManufacture'">
          <el-checkbox
            size="small"
            v-model="addPhasePriceObj.asyncManufacture"
            >{{ $t("prompt.asyncManufacture") }}</el-checkbox
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addPhasePriceDoing"
          size="small"
          @click="addPhasePriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addPhasePriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑工序 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editPhasePriceDF"
      width="30%"
    >
      <el-form
        ref="editPhasePriceObjForm"
        :model="editPhasePriceObj"
        label-width="70px"
      >
        <el-form-item
          :label="$t('factory.phasePrice')"
          :prop="'phasePrice'"
          :rules="[
            { required: true, validator: validatePhasePrice, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="editPhasePriceObj.phasePrice" />
        </el-form-item>
        <el-form-item :prop="'asyncPhasePlan'">
          <el-checkbox
            size="small"
            v-model="editPhasePriceObj.asyncPhasePlan"
            >{{ $t("prompt.asyncPhasePlan") }}</el-checkbox
          >
        </el-form-item>
        <el-form-item :prop="'asyncManufacture'">
          <el-checkbox
            size="small"
            v-model="editPhasePriceObj.asyncManufacture"
            >{{ $t("prompt.asyncManufacture") }}</el-checkbox
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editPhasePriceDoing"
          size="small"
          @click="editPhasePriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPhasePriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Factory from "@/api/factory.js";
import User from "@/api/user.js";
import UserFactory from "@/api/userFactory.js";
import Phase from "@/api/phase.js";
export default {
  props: {
    id: Number,
  },
  mixins: [page],
  data() {
    var validatePhasePrice = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(
          new Error(self.$t("rules.required", [self.$t("factory.phasePrice")]))
        );
        return;
      }
      if (!Util.regexPrice(value)) {
        callback(
          new Error(self.$t("rules.regex", [self.$t("factory.phasePrice")]))
        );
        return;
      } else {
        callback();
      }
    };
    return {
      factory: { name: null, xcxViewImages: false, xcxViewPhasePrice: false },
      factoryUsers: [],
      phasePrices: [],

      // 新增用户
      users: [],
      addUserFactoryDF: false,
      checkedUserIds: [],
      usersFilter: [],
      addUserFactoryDoing: false,

      // 新增
      validatePhasePrice: validatePhasePrice,
      phasesFilter: [],
      addPhasePriceDF: false,
      addPhasePriceObj: {
        factoryId: null,
        phaseId: null,
        phasePrice: null,
        asyncManufacture: true,
        asyncPhasePlan: true,
      },
      addPhasePriceDoing: false,
      // 编辑
      editPhasePriceDF: false,
      row: null,
      editPhasePriceObj: {
        phasePrice: null,
        asyncManufacture: true,
        asyncPhasePlan: true,
        factoryId: null,
        phaseId: null,
      },
      editPhasePriceDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    Factory.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.factory = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
      self.getUserFactories();
      self.getPhasePrices();
    });
  },
  methods: {
    deletePhasePrice(row) {
      const self = this;
      Factory.deletePhases(self.factory.id, row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getPhasePrices();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑
    editPhasePrice(row) {
      const self = this;
      self.row = row;
      self.editPhasePriceObj.factoryId = self.factory.id;
      self.editPhasePriceObj.phaseId = row.phaseId;
      self.editPhasePriceObj.phasePrice = row.phasePrice;
      self.editPhasePriceObj.asyncManufacture = true;
      self.editPhasePriceObj.asyncPhasePlan = true;

      self.editPhasePriceDoing = false;
      self.editPhasePriceDF = true;
    },
    editPhasePriceSubmit() {
      const self = this;
      self.$refs.editPhasePriceObjForm.validate((valid) => {
        if (valid) {
          self.editPhasePriceDoing = true;
          Factory.updatePhases(
            self.factory.id,
            self.row.id,
            self.editPhasePriceObj
          ).then(function (res) {
            self.editPhasePriceDoing = false;
            self.editPhasePriceDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getPhasePrices();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增工序
    addPhasePrice() {
      const self = this;
      self.addPhasePriceObj.factoryId = self.factory.id;
      self.addPhasePriceObj.phaseId = null;
      self.addPhasePriceObj.phasePrice = null;
      self.addPhasePriceObj.asyncManufacture = true;
      self.addPhasePriceObj.asyncPhasePlan = true;
      self.addPhasePriceDoing = false;
      Phase.findByTenantId().then(function (res) {
        if (res.status === 200) {
          const phases = res.data;
          self.phasesFilter = phases.filter(
            (p) => self.phasePrices.find((pp) => pp.phaseId === p.id) == null
          );
        } else {
          self.sysError();
        }
        self.addPhasePriceDF = true;
      });
    },
    addPhasePriceSubmit() {
      const self = this;
      self.$refs.addPhasePriceObjForm.validate((valid) => {
        if (valid) {
          self.addPhasePriceDoing = true;
          Factory.createPhases(self.factory.id, [self.addPhasePriceObj]).then(
            function (res) {
              self.addPhasePriceDoing = false;
              self.addPhasePriceDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.addSuccess"),
                  type: "success",
                });
                self.getPhasePrices();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 新增用户
    addUserFactory() {
      const self = this;
      self.checkedUserIds = [];
      User.findByTenantId(self.Permit.currentTenant().id).then(function (res) {
        if (res.status === 200) {
          self.users = res.data.filter((u) => u.voidAt == null);
          const factoryUserIds = self.factoryUsers.map((f) => f.userId);
          self.usersFilter = self.users.filter(
            (u) => u.admin !== true && !factoryUserIds.includes(u.id)
          );
          self.addUserFactoryDF = true;
        } else {
          self.sysError();
        }
      });
    },
    addUserFactorySubmit() {
      const self = this;
      if (self.checkedUserIds.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const obj = self.checkedUserIds.map((c) => {
        return { userId: c, factoryId: self.factory.id };
      });
      self.addUserFactoryDoing = true;
      UserFactory.insertBatch(obj).then(function (res) {
        if (res.status === 200) {
          self.addUserFactoryDF = false;
          self.addUserFactoryDoing = false;
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.getUserFactories();
        } else {
          self.sysError();
        }
      });
    },
    // 删除用户
    deleteUserFactory(factoryUser) {
      const self = this;
      UserFactory.delete(factoryUser.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getUserFactories();
        } else {
          self.sysError();
        }
      });
    },

    getUserFactories() {
      const self = this;
      UserFactory.findByFactoryId(self.id).then(function (res) {
        if (res.status === 200) {
          self.factoryUsers = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getPhasePrices() {
      const self = this;
      Factory.findPhases(self.id).then(function (res) {
        if (res.status === 200) {
          self.phasePrices = res.data;
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>